import { API_VERSION, PATH_USERS_API } from '../constants/api-routes';
import { baseSsoApi } from 'src/services/base.sso.api';

export const usersSsoService = baseSsoApi.injectEndpoints({
  endpoints: (build) => ({
    userRegistration: build.mutation({
      query: ({
        email = '',
        first_name = '',
        last_name = '',
        password = '',
        password2 = '',
        company_name = '',
        company_email = '',
      }) => ({
        url: `${API_VERSION.V1}/${PATH_USERS_API.REGISTRATION}`,
        method: 'POST',
        body: {
          email,
          first_name,
          last_name,
          password,
          password2,
          company_name,
          company_email,
        },
      }),
    }),
    resendVerificationEmail: build.mutation({
      query: () => ({
        url: `${API_VERSION.V1}/${PATH_USERS_API.RESEND_VERIFICATION_EMAIL}`,
        method: 'POST',
      }),
    }),
    validateRegistrationFields: build.mutation({
      query: ({ body }) => ({
        url: `${API_VERSION.V1}/${PATH_USERS_API.VALIDATE_FIELDS}`,
        method: 'POST',
        body: body,
      }),
    }),
  }),
});

export const {
  useUserRegistrationMutation,
  useResendVerificationEmailMutation,
  useValidateRegistrationFieldsMutation,
} = usersSsoService;
